module.exports = __webpack_public_path__ + "public/Icons/linkedin.png?c7b24e39";